import Progress from "antd/lib/progress";
import { parseISO } from "date-fns";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getTimeProgressPercentage } from "src/features/dashboards/functions";

import { IClassroomItem } from "@sol/sdk";

type ClassroomProgressionProps = {
    classroom: IClassroomItem;
    className?: string;
    showText?: boolean;
    size?: number | "small" | "default";
};

export function ClassroomProgression({
    classroom,
    className,
    showText = true,
    size = "default",
}: ClassroomProgressionProps) {
    const [t] = useTranslation();

    const progressData = useMemo(() => {
        const now = new Date();
        const startDate = parseISO(classroom.startDate);
        const endDate = parseISO(classroom.endDate);

        const percentage = getTimeProgressPercentage(startDate, endDate, now);

        const statusText = t("component.home.ClassroomProgression.promotionText", {
            startDate,
            endDate,
        });

        return { percentage, statusText };
    }, [classroom.startDate, classroom.endDate, t]);

    return (
        <div className={className}>
            <Progress
                percent={progressData.percentage}
                status={"active"}
                size={typeof size === "number" ? ["default", size] : size}
                showInfo={showText}
                format={percent => (showText ? `${percent}%` : undefined)}
            />
            {showText && (
                <div className="text-ant-secondary mt-ant-xs text-right text-ant-sm">{progressData.statusText}</div>
            )}
        </div>
    );
}
